/** E-stop topic & service (ROS 2). */

/** Merged engaged state from `gb_control` (physical + software). */
export const E_STOP_TOPIC = "/state/estop";
/** Physical latch from `r2c2_controlboard` (`pressed: 0` → `data: true`). */
export const HARDWARE_ESTOP_TOPIC = "/hardware/estop";
/** Software latch from the webapp (mirrors `/hardware/estop` shape: `std_msgs/Bool`). */
export const SOFTWARE_ESTOP_TOPIC = "/software/estop";
export const ESTOP_BOOL_MSG_TYPE = "std_msgs/Bool";
export const E_STOP_SET_SERVICE = "/set_estop";
/** Request uses `std_srvs/srv/SetBool` (`data` field). */
export const E_STOP_SET_SERVICE_TYPE = "std_srvs/srv/SetBool";

/** rosbridge v2.1+ `subscribe` QoS: match transient-local state publishers. */
export const E_STOP_SUBSCRIBE_QOS = {
    durability: "transient_local",
    reliability: "reliable",
    history: "keep_last",
    depth: 10,
};

/**
 * @param {boolean} engaged
 * @returns {[string, { data: boolean }, { serviceType: string }]}
 */
export const setEstopService = (engaged) => [
    E_STOP_SET_SERVICE,
    { data: engaged },
    { serviceType: E_STOP_SET_SERVICE_TYPE },
];

/**
 * Publish software E-STOP (same Bool semantics as `/hardware/estop`).
 * @param {boolean} engaged
 * @returns {[string, boolean, string]}
 */
export const publishSoftwareEstop = (engaged) => [
    SOFTWARE_ESTOP_TOPIC,
    engaged,
    ESTOP_BOOL_MSG_TYPE,
];

/**
 * Normalize `/state/estop` payloads (std_msgs/Bool, custom, or nested `data`).
 * @param {unknown} msg
 * @returns {boolean | null}
 */
export const parseEstopTopicPayload = (msg) => {
    if (msg == null) return null;
    if (typeof msg === "boolean") return msg;
    if (typeof msg === "number") return msg !== 0;
    if (typeof msg === "object") {
        if (typeof msg.data === "boolean") return msg.data;
        if (typeof msg.data === "number") return msg.data !== 0;
        if (typeof msg.pressed === "boolean") return msg.pressed;
        if (typeof msg.pressed === "number") return msg.pressed !== 0;
    }
    return null;
};
